import { render, staticRenderFns } from "./ModalPointHistory.vue?vue&type=template&id=033f4b0f&scoped=true&lang=pug&"
import script from "./ModalPointHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalPointHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPointHistory.vue?vue&type=style&index=0&id=033f4b0f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033f4b0f",
  null
  
)

export default component.exports